import { NavLink, useLocation } from "react-router-dom";
import { Target, Mic, BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";

const TABS = [
  { to: "/logros", labelKey: "tabs.logros", icon: Target, testId: "tab-logros", matchPaths: ["/", "/logros"] },
  { to: "/ia", labelKey: "tabs.ia", icon: Mic, testId: "tab-ia", matchPaths: ["/ia"] },
  { to: "/metricas", labelKey: "tabs.metricas", icon: BarChart3, testId: "tab-metricas", matchPaths: ["/metricas"] },
];

function TabItem({ to, label, icon: Icon, testId, isActive }) {
  return (
    <NavLink
      to={to}
      data-testid={testId}
      data-active={isActive ? "true" : "false"}
      className="
        group relative flex flex-1 flex-col items-center justify-center
        gap-1 py-2 px-1
        outline-none focus-visible:ring-1 focus-visible:ring-[#00E5FF]/40 rounded-xl
      "
    >
      {/* Active top indicator */}
      <span
        className={`
          absolute top-0 left-1/2 -translate-x-1/2 h-[2px] w-8 rounded-full
          transition-all duration-300
          ${isActive ? "bg-[#00E5FF] shadow-[0_0_10px_rgba(0,229,255,0.7)] opacity-100" : "opacity-0"}
        `}
        aria-hidden="true"
      />

      <Icon
        className={`
          h-[22px] w-[22px] transition-all duration-300
          ${
            isActive
              ? "text-[#00E5FF] [filter:drop-shadow(0_0_6px_rgba(0,229,255,0.55))]"
              : "text-[#9CA3AF] group-hover:text-[#E5E7EB]"
          }
        `}
        strokeWidth={isActive ? 2.25 : 1.75}
      />
      <span
        className={`
          text-[10.5px] font-medium tracking-wide transition-colors duration-300
          ${isActive ? "text-[#00E5FF]" : "text-[#9CA3AF] group-hover:text-[#E5E7EB]"}
        `}
      >
        {label}
      </span>
    </NavLink>
  );
}

export default function BottomTabBar() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <nav
      className="
        relative z-[9999] shrink-0
        border-t border-[rgba(0,229,255,0.1)]
        bg-[rgba(7,11,20,0.85)] backdrop-blur-xl
        flex flex-col
      "
      data-testid="bottom-tab-bar"
    >
      {/* Tab items — fixed 72px row on every viewport */}
      <div className="flex items-stretch h-[72px] px-3">
        {TABS.map((tab) => {
          const isActive = tab.matchPaths.includes(pathname);
          return <TabItem key={tab.to} {...tab} label={t(tab.labelKey)} isActive={isActive} />;
        })}
      </div>

      {/* Mobile-only safe area spacer to keep the icons above the Emergent
          "Made with" badge (fixed bottom-right of the viewport). Inherits the
          nav's bg + backdrop-blur so visually it's a single continuous block.
          Combines a 64px offset with the device's safe-area-inset-bottom so
          iPhones with a home indicator also stay clear. */}
      <div
        aria-hidden="true"
        data-testid="bottom-tab-bar-safe-area"
        className="md:hidden shrink-0"
        style={{ height: "calc(64px + env(safe-area-inset-bottom, 0px))" }}
      />
    </nav>
  );
}
